import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { BusinessModuleRoutes } from './business/business.route';
import { MenuService } from './shared-resources/services/menu.service';
import { UserInfoService } from './shared-resources/services/user-info.service';
import { AddModulesPath } from './shared-resources/store/base.action';
import { Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { NotifyService } from './layout/services/notify.service';
import { LoginService } from './layout/services/login.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit, OnDestroy {
  private storageListener: (event: StorageEvent) => void;
  private isLogoutFromOtherTab = false;

  constructor(
    public menuService: MenuService,
    public userInfo: UserInfoService,
    private store: Store,
    private router: Router,
    private notifyService: NotifyService,
    private loginService: LoginService
  ) {
    this.storageListener = (event: StorageEvent) => {
      if (event.key === 'logout-event') {
        this.isLogoutFromOtherTab = true;
        sessionStorage.clear();
        document.cookie.split(';').forEach((c) => {
          document.cookie = c.replace(/^ +/, '').replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
        });
        window.location.hash = '#/login';
        window.location.reload();
      }
    };
    window.addEventListener('storage', this.storageListener);
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(): void {
    if (this.isLogoutFromOtherTab) return;
    console.log('refresh start......................!!!!');
    this.userInfo.setSessionCookies();
    this.userInfo.userLogout('windowclose');
  }

  ngOnInit(): void {
    this.userInfo.getUserInfo$().pipe(
      filter((user: any) => !!user?.userInfoId)
    ).subscribe((user: any) => {
      const token = this.userInfo.getUserToken();
      console.log('[AppComponent] getUserInfo$ emitted. userInfoId:', user?.userInfoId, '| token present:', !!token);
      if (token) {
        this.notifyService.connect(user.userInfoId, token);
        this.loginService.getUnreadCount(user.userInfoId).subscribe(
          (res: any) => this.notifyService.setCount(res?.count ?? res ?? 0)
        );
      }
    });
    const route = [...BusinessModuleRoutes];
    const moduleRoute: any[] = [];
    route.forEach((r) => {
      moduleRoute.push(r.path);
    });
    this.store.dispatch(new AddModulesPath(moduleRoute));
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this.storageListener);
  }
}
